import { createStore } from 'vuex'

export default createStore({
  strict: false,
  state: {},
  mutations: {},
  actions: {},
  modules: {},
})
